var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flickity',{ref:"flickity",attrs:{"options":_vm.flickityOptions}},_vm._l((_vm.imageurls),function(imageUrl,index){return _c('img',{key:`${index}image`,staticClass:"gallery__photo",attrs:{"data-flickity-lazyload":imageUrl,"alt":"Photos relevant to the case study"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }